import axios from 'axios';
import { rmubase } from '@/config';

export default {
  async getRichMenuID(params) {
    try {
      const res = await axios.get(`${rmubase}api/v1/richmenuid`, { params });
      return res.data;
    } catch (err) {
      return err.response;
    }
  },
  async postMemberMenu(body) {
    try {
      const res = await axios.post(`${rmubase}api/v1/memberMenu`, body);
      return res.data;
    } catch (err) {
      return err.response;
    }
  },
  // 新增使用者與圖文管理關係檔 V2
  async postMemberMenuV2(body) {
    try {
      const res = await axios.post(`${rmubase}api/v2/memberMenu`, body);
      return res.data;
    } catch (err) {
      return err.response;
    }
  }
};
